{
  "configurationModal": {
    "title": "Crear nueva configuración de la página",
    "name": "Nombre de la configuración"
  },
  "editHomePageModal": {
    "title": "Editar página de inicio",
    "name": "Nombre de la página",
    "save": "Guardar"
  },
  "editor": {
    "description": "Configure los widgets y el contenido para el diseño de esta página de inicio.",
    "saveChanges": "Guardar cambios",
    "delete": "Eliminar configuración",
    "addWidget": "Añadir widget",
    "edit": "Editar",
    "deleteConfirmation": "¿Confirma que desea eliminar esta configuración de página de inicio? Esta acción no se puede deshacer."
  },
  "widget": {
    "addWidget": "Añadir widget a la página de inicio",
    "editWidget": "Editar widget",
    "options": "Opciones de widget",
    "noWidgets": "No hay widgets configurados. Agregue un widget para comenzar.",
    "freeFormInput": {
      "title": "Contenido de formato libre",
      "description": "Agregue contenido personalizado, texto y medios a la página de inicio"
    }
  },
  "practiceOverview": {
    "totalAum": "Total de activos bajo gestión (AUM)",
    "averageAum": "AUM promedio por cliente",
    "totalClients": "Clientes en total",
    "netflows": "Flujos netos",
    "managementFees": "Tarifas de gestión",
    "fundedClients": "Clientes financiados",
    "cashPercentage": "Porcentaje de efectivo",
    "fromLastMonth": "del mes pasado"
  },
  "welcome": "Bienvenido",
  "other": "Otro",
  "aumExplorer": {
    "accountType": "Tipo de cuenta",
    "modelPortfolio": "Cartera modelo",
    "childOrganization": "Organización infantil",
    "repCode": "Código de representante",
    "noData": "No hay información disponible"
  },
  "feesAndRevenue": {
    "noFeesCollectedYet": "Aún no se cobran tarifas",
    "timeFrame": {
      "1Y": "1Y",
      "YTD": "Acumulado hasta la fecha"
    }
  },
  "report": {
    "filter": {
      "any": "Cualquiera",
      "individual": "Individual",
      "nonIndividual": "No individual"
    }
  },
  "productAumExposure": {
    "security": "Valor",
    "selectSecurity": "Seleccione un valor para ver las clasificaciones de exposición.",
    "noResults": "Ningún cliente posee este valor.",
    "summary": "La exposición total a {{productName}} ({{ticker}}) es {{totalMarketValue}}. Esta exposición se distribuye entre {{count}} {{levelLabel}}. A continuación, se muestra la lista clasificada por exposición:",
    "exposureLevels": {
      "HOUSEHOLD_one": "unidad familiar",
      "HOUSEHOLD_other": "unidades familiares",
      "ENTITY_one": "entidad",
      "ENTITY_other": "entidades",
      "ACCOUNT_one": "cuenta",
      "ACCOUNT_other": "cuentas"
    },
    "exportFileName": "Exposición_AUM_Producto",
    "exportProgressTitle": "Exportando exposición AUM del producto",
    "columns": {
      "rank": "Clasificación",
      "householdName": "Unidad familiar",
      "entityName": "Entidad",
      "firstName": "Nombre",
      "lastName": "Apellido",
      "accountName": "Cuenta",
      "accountType": "Tipo de cuenta",
      "accountNumber": "Número de cuenta",
      "marketValue": "Valor de mercado"
    }
  }
}
